import React, { useState, useEffect, Fragment, forwardRef } from 'react';
import { Row, Label, Col, Button, Input, Form, FormGroup, Card } from "reactstrap";
import axios from 'axios';
import { useForm } from 'react-hook-form';
import Dropzone from 'react-dropzone-uploader';
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { mykyc, setDealerGstnVerify } from '../../../../../redux/kyc/action';
import validateFile from '../../../../../utilities/validateFile';
import handleupload from '../../../../../utilities/handleUpload';
import PDFViewer from '../../../../../utilities/PDFViewer';
import { Edit, InfoOutlined } from '@mui/icons-material';
import FileUploadComponent from '../../../../common/FileUpload';
import RequiredIndicator from '../../../../partial/RequiredIndicator';
import KycViewNote from '../../kyc_note/KycViewNote';
import KycEditNote from '../../kyc_note/KycEditNote';
import { stateCityByPincode, updateDealer, validateGstnNumber } from '../../../../../api';
import { getFromLocalStorage } from '../../../../../hooks/useLocalStorage';
import specialCharacterConstrains from '../../../../../utilities/specialCharacterConstrains';
import { verifyButton } from '../../../../../constant';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { watch } from 'fs';

const Gstn = (props, ref) => {

    const { activeStep, setActiveStep, setStep2Valid, dealerKycData, is_kyc_submitted, is_kyc_active, setIsUpdated, partnershipData, re_kyc, setIsGSTDocUpdated } = props;
    console.log("props==>", props);
    const kycData = useSelector((content) => content.Kyc);
    const showReadOnlyGstn = (is_kyc_submitted || is_kyc_active) && re_kyc;
    const isGstReadOnly = !!kycData?.gstin?.gstinVerify && !re_kyc;

    const { handleSubmit, register, setValue, trigger, getValues, errors, setError } = useForm();
    const [loading, setLoading] = useState(false);
    const [pinCode, setPinCode] = useState('');
    const [dealerName, setDealerName] = useState('');
    const [gstinAccName, setGstinAccName] = useState('');
    // Removed defaultEntityType and entity_type logic
    const [gstnState, setGstnState] = useState('');
    const [gstnStateCode, setGstnStateCode] = useState("");
    const [gstnEditable, setGstnEditable] = useState(kycData?.gstin?.gstin_number_last_three_digit ? kycData?.gstin?.gstin_number_last_three_digit : kycData?.gstin?.gstin_number?.length > 13 ? kycData?.gstin?.gstin_number.slice(-3) : "");
    const [isNewGstUploaded, setIsNewGstUploaded] = useState(false);
    const [gstUrl, setGstUrl] = useState("");
    const dispatch = useDispatch();
    console.log(kycData, "kycData in gstn component")
    const [isgstnVerify, setIsGstnVerify] = useState(false);
    const [isGstnVerification, setIsGstnVerification] = useState(false);
    const [panVerifiedDealerName, setPanVerifiedDealerName] = useState("");
    const [tradeName, setTradeName] = useState("");

    const fetchPincodeDetails = async (pincode) => {
        try {
            const res = await stateCityByPincode(pincode);
            console.log(res, "pincode details")
            const pincodeData = res.data?.result;
            if (pincodeData && pincodeData?.stateSchema?.state_gst_code) {
                setGstnStateCode(pincodeData?.stateSchema?.state_gst_code)
            }
        } catch (err) {
            toast.error("err in fetch pincode details")
        }
    };

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));
        const pin_code = user?.partnerInfo?.pin_code || user?.pin_code;
        const gstnDealerState = user?.partnerInfo?.state  || user?.state;
        const dealer_name = user?.partnerInfo?.name;
        setPinCode(pin_code);
        setGstnState(gstnDealerState);
        fetchPincodeDetails(pin_code);
        setDealerName(dealer_name);
        setTradeName(kycData.gstin?.gstin_account_name);
        async function checkDetails() {
            const storedData = kycData.gstin;
            Object.keys(storedData).forEach((fieldName) => {
                setValue(fieldName, storedData[fieldName]);
            });
            setValue('gstin_state', gstnDealerState);
            setValue('gstin_pincode', pin_code);
            setValue('gstin_account_name', storedData?.gstin_account_name);
            setGstUrl(getValues()["gstin_image"])
        }
        checkDetails()
    }, [kycData.panCard?.user_pan_card_number, kycData.panCard?.user_pan_card_name]);

    const submitForm = (data) => {
        // if(!kycData?.gstin?.gstinVerify){
        //     toast.error('GSTIN not verified');
        //     return;
        // }
        setLoading(true);
        const latestGstImage = getValues("gstin_image");

        const gstin_number = data.gstn_state_code + kycData?.panCard?.user_pan_card_number + data.gstin_number_last_three_digit;
        // Remove entity_type from the payload
        const { entity_type, ...restData } = data;
        dispatch(mykyc({ ...kycData, gstin: { ...kycData.gstin, ...restData, gstin_image: latestGstImage, gstin_number: gstin_number, tradeName:tradeName }, txnid: Date.now() }));
        setIsUpdated(true)
        setTimeout(() => {
            setIsUpdated(false)
        }, 2000);
        if (activeStep === 1) {
            setLoading(false);
            setStep2Valid(true);
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const verifyGstnDetails = async (data) => {
        setIsGstnVerification(false);
        const dealer_name = partnershipData?.dealer_name;
        const partnership_id = partnershipData?.partnership_id;
        const dealer_gstn_number = data;
        setIsGstnVerify(true);
        try {
            const gstnPayload = { gstNumber: dealer_gstn_number }
            const gstnVerifiedRes = await validateGstnNumber(gstnPayload);
            const gstn_verification_status = gstnVerifiedRes?.data?.result?.msg?.basicDetails?.registrationStatus;
            const tradeName = gstnVerifiedRes?.data?.result?.msg?.basicDetails?.tradeName;
            const legalBusinessName = gstnVerifiedRes?.data?.result?.msg?.basicDetails?.legalBusinessName;
            if(tradeName == "" || tradeName == "NA"){
                setTradeName(legalBusinessName);
            } else {
                setTradeName(tradeName);
            }
            Swal.fire({
                icon: 'info',
                html: `Verification status of the provided GSTIN(<b>${dealer_gstn_number}</b>) is <b>${gstn_verification_status}</b>.`,
                showCancelButton: false,
                confirmButtonText: 'Ok',
            })
            setIsGstnVerification(true);
            dispatch(setDealerGstnVerify(true));
        } catch (error) {
            toast.error(error?.response?.data?.error ? error?.response?.data?.error : 'Something went wrong');
            setIsGstnVerify(false);
            return;
        }
        setIsUpdated(true)
        setTimeout(() => {
            setIsUpdated(false)
        }, 2000);
    };

    const gstPattern = /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-8]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/gi

    const handleBack = () => {
        if (is_kyc_submitted) {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        } else {
            const rhfdata = getValues()
            // Remove entity_type from the payload
            const { entity_type, ...restData } = rhfdata;
            dispatch(mykyc({ ...kycData, gstin: restData, txnid: Date.now() }));
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
    };

    const existingGstDocument = kycData?.gstin?.gstin_image;
    const onSubmitForKycSubmitComplete = () => {

        const currentGstDocument = getValues("gstin_image");
        if (re_kyc && (!currentGstDocument || currentGstDocument === existingGstDocument)) 
        {
            toast.error("Please upload a new GST document for Re-KYC");
            return;
        }
        else{
            setIsGSTDocUpdated(true);
        }

        //updating dispatch gstin image
        const updatedData = {
            ...kycData,
            gstin: {
                ...kycData.gstin,
                gstin_image: currentGstDocument
            },
            txnid: Date.now()
        };

        dispatch(mykyc(updatedData));

        if (activeStep === 1) {
            setStep2Valid(true);
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    return (
        <Fragment>
            <Row>
                <Col xl="12" md="12" sm="12" className="mt-4" key={1}>
                    <div className="project-box">
                        {is_kyc_active && !re_kyc ? (<span className={`badge badge-success`}>{"Verified"}</span>) : ''}
                        <div className='mt-3'>
                            {showReadOnlyGstn ? (
                                <>
                                    <Row>
                                        <Col xl="6" md="6">
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"State"}</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="gstin_state"
                                                            type="text"
                                                            defaultValue={kycData?.gstin?.gstin_state}
                                                            readOnly
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"Pincode"}</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="gstin_pincode"
                                                            type="text"
                                                            defaultValue={kycData?.gstin?.gstin_pincode}
                                                            readOnly
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            {/* <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"Entity Type"}</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="entity_type"
                                                            type="text"
                                                            defaultValue={kycData?.gstin?.entity_type}
                                                            readOnly
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row> */}
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"GSTN No."}</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="gstin_number"
                                                            type="text"
                                                            defaultValue={kycData?.gstin?.gstin_number}
                                                            readOnly
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"Name in the Account"}</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="gstin_account_name"
                                                            type="text"
                                                            defaultValue={kycData?.gstin?.gstin_account_name}
                                                            readOnly
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <KycViewNote />
                                        </Col>
                                        {!re_kyc ?
                                            <Col xl="6" md="6" className="d-flex justify-content-center">
                                                <FormGroup className='text-center'>
                                                    <Label>{"GSTN document"}</Label>
                                                    <FileUploadComponent name="gstin_image" fileUploadFlag={false} data={kycData?.gstin?.gstin_image} viewOnly={true} />
                                                </FormGroup>
                                            </Col> : <Col xl="6" md="6" className="d-flex justify-content-center">
                                                <FormGroup style={{ textAlign: 'center' }}>
                                                    <Label>{"Upload GSTN document"}</Label> <RequiredIndicator />
                                                    <FileUploadComponent
                                                        register={register}
                                                        name="gstin_image"
                                                        setValue={setValue}
                                                        trigger={trigger}
                                                        getValues={getValues}
                                                        data={re_kyc ? null : gstUrl}
                                                        // add={true}
                                                        add={getValues()["gstin_image"]?.length > 0 ? false : true}
                                                        pdfImageOnly={true}
                                                        setIsNewGstUploaded={setIsNewGstUploaded}
                                                    />
                                                    <span style={{ color: "red" }}>
                                                        {errors.gstin_image && "GST Document is Required"}
                                                    </span>
                                                </FormGroup>
                                            </Col>
                                        }
                                    </Row>
                                    <Row className="justify-content-between">
                                        <Col md="auto">
                                            {activeStep !== 0 && (
                                                <Button
                                                    color="info"
                                                    disabled={activeStep === 0}
                                                    onClick={handleBack}
                                                >
                                                    Back
                                                </Button>
                                            )}
                                        </Col>
                                        <Col md="auto">
                                            <Button type="submit" color="info" onClick={onSubmitForKycSubmitComplete}>
                                                Next
                                            </Button>
                                        </Col>
                                    </Row>
                                </>
                            ) : (
                                <Form className="form-bookmark needs-validation" onSubmit={handleSubmit(submitForm)} >
                                    <Row>
                                        <Col xl="6" md="6">
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"State"}</Label> <RequiredIndicator />
                                                        <Input
                                                            className="form-control"
                                                            name="gstin_state"
                                                            type="text"
                                                            innerRef={register({ required: true })}
                                                            value={gstnState}
                                                            readOnly={!re_kyc}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setGstnState(value);
                                                                setValue('gstin_state', value);
                                                            }}
                                                        />
                                                        <span style={{ color: "red" }}>
                                                            {errors.gstin_state && "State is required"}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"Pincode"}</Label> <RequiredIndicator />
                                                        <Input
                                                            className="form-control"
                                                            name="gstin_pincode"
                                                            type="text"
                                                            innerRef={register(specialCharacterConstrains(true, "PIN Code is required"))}
                                                            value={pinCode}
                                                            readOnly={!re_kyc}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setPinCode(value);
                                                                setValue('gstin_pincode', value);
                                                                if (value?.length === 6) {
                                                                    fetchPincodeDetails(value);
                                                                }
                                                            }}
                                                        />
                                                        <span style={{ color: "red" }}>
                                                            {errors.gstin_pincode?.message}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            {/* Entity Type removed from editable form */}
                                            <Row>
                                                <Col xl="9" md="9">
                                                    <FormGroup>
                                                        <Label>{"GSTN No."}</Label> <RequiredIndicator />
                                                        <Row style={{ display: 'flex', alignItems: 'center', marginLeft: 0 }}>
                                                            <Input
                                                                className="form-control"
                                                                type="text"
                                                                name="gstn_state_code"
                                                                value={gstnStateCode}
                                                                innerRef={register(specialCharacterConstrains(true, 'GST State Code is required'))}
                                                                style={{ width: '15%' }}
                                                                readOnly
                                                            />
                                                            <Input
                                                                className="form-control"
                                                                type="text"
                                                                value={kycData?.panCard?.user_pan_card_number}
                                                                style={{ width: '50%', marginLeft: 10 }}
                                                                readOnly
                                                            />
                                                            <Input
                                                                className="form-control"
                                                                name="gstin_number_last_three_digit"
                                                                type="text"
                                                                maxLength={3}
                                                                innerRef={register({
                                                                    required: 'GST Number is required', pattern: { value: /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]*$/, message: 'GST Number must be alphanumeric and at least 3 characters long' }, minLength: { value: 3, message: 'GST Number must be at least 3 characters long' },
                                                                })}
                                                                value={getValues()["gstin_number_last_three_digit"] ? getValues()["gstin_number_last_three_digit"] : gstnEditable}
                                                                onChange={(e) => {
                                                                    const upperCaseGstn = e.target.value.toUpperCase();
                                                                    setGstnEditable(upperCaseGstn)
                                                                    setValue("gstin_number_last_three_digit", upperCaseGstn)
                                                                    trigger("gstin_number_last_three_digit")
                                                                }}
                                                                style={{ width: '27%', marginLeft: 10 }}
                                                                readOnly={isGstReadOnly}
                                                            />
                                                        </Row>
                                                        <span style={{ color: "red" }}>
                                                            {errors?.gstin_number_last_three_digit && errors?.gstin_number_last_three_digit?.message}
                                                            {errors?.gstn_state_code && errors?.gstn_state_code?.message}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                                <Col xl="3" md="3" className="verify-button">
                                                    {kycData?.gstin?.gstinVerify ?
                                                        <Button color="success" className="verify-gst-button" disabled>
                                                            <FontAwesomeIcon icon={faCheck} />
                                                        </Button>
                                                        :
                                                    <Button color="info"
                                                        className="verify-gst-button"
                                                        onClick={() => {
                                                            const gstnNumberLastThreeDigit = getValues()["gstin_number_last_three_digit"];
                                                            if (!gstnNumberLastThreeDigit) {
                                                                toast.error("Please enter GSTIN number");
                                                                return;
                                                            }
                                                            verifyGstnDetails(`${gstnStateCode}${kycData?.panCard?.user_pan_card_number}${getValues()["gstin_number_last_three_digit"]}`);
                                                        }} disabled={isgstnVerify}> {verifyButton} </Button>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"Name in the Account"}</Label> <RequiredIndicator />
                                                        <Input
                                                            className="form-control"
                                                            name="gstin_account_name"
                                                            type="text"
                                                            innerRef={register(specialCharacterConstrains(true, "Name in the Account is required"))}
                                                            value={tradeName}
                                                            readOnly
                                                        />
                                                        <span style={{ color: "red" }}>
                                                            {errors?.gstin_account_name && "Name in the Account is required"}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <KycEditNote />
                                        </Col>
                                        <Col xl="6" md="6" className="d-flex justify-content-center">
                                            <FormGroup style={{ textAlign: 'center' }}>
                                                <Label>{"Upload GSTN document"}</Label> <RequiredIndicator />
                                                <FileUploadComponent
                                                    register={register}
                                                    name="gstin_image"
                                                    setValue={setValue}
                                                    trigger={trigger}
                                                    getValues={getValues}
                                                    data={gstUrl}
                                                    add={getValues()["gstin_image"]?.length > 0 ? false : true}
                                                    pdfImageOnly={true}
                                                />
                                                <span style={{ color: "red" }}>
                                                    {errors.gstin_image && "GST Document is Required"}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className="justify-content-between">
                                        <Col md="auto">
                                            {activeStep !== 0 && (
                                                <Button
                                                    color="info"
                                                    disabled={activeStep === 0}
                                                    onClick={handleBack}
                                                >
                                                    &lt;&lt; Back
                                                </Button>
                                            )}
                                        </Col>
                                        <Col md="auto">
                                            <Button type="submit" color="info">
                                                {loading ? "Loading..." : "Save"} <span>&gt;&gt;</span>
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
        </Fragment>
    )
};

export default Gstn;